export default {"src":"/_next/static/media/client-2-2.b549ab00.svg","height":48,"width":143,"blurWidth":0,"blurHeight":0};